import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostBinding,
  OnInit,
  inject
} from '@angular/core';

import {
  Router,
  NavigationEnd,
  Event,
  RouterLinkActive
} from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'stars-menu',
  templateUrl: './menu.html',
  styleUrls: ['./menu.scss'],
  imports: [NgClass, RouterLinkActive]
})
export class MenuComponent implements OnInit {
  private router = inject(Router);

  @HostBinding('class.open')
  @Input()
  open = true;
  menuItemDropdown = false;
  route: string;

  @Output() toggleMenu = new EventEmitter<any>();

  // This toggles the "Apps" sub-menu on mobile click. Hover is handled in the scss.
  toggleMenuItemDropdown(): void {
    this.menuItemDropdown = !this.menuItemDropdown;
  }

  ngOnInit(): void {
    // Activates the "Apps" dropdown button border if the route contains '/apps'
    this.route = this.router.url;
    const dropdownButton =
      document.getElementsByClassName('dropdown-button')[0];
    this.router.events.subscribe((event: Event) => {
      this.menuItemDropdown = false;
      if (event instanceof NavigationEnd) {
        if (event.url.includes('/apps/')) {
          dropdownButton.classList.add('active');
        } else {
          dropdownButton.classList.remove('active');
        }
      }
    });
  }
}
